import { phoneNumberFormatter } from '../../phoneNumberFormatter'

export const setUpBankContactPhoneField = ($form) => {
  const bankContactPhoneNumberInput = $form[0].querySelector('#bank_contact_phone');
  const bankContactPhoneNumberErrorMesage = $form[0].querySelector('#bank_contact_phone_error_message');

  phoneNumberFormatter(bankContactPhoneNumberInput, bankContactPhoneNumberErrorMesage);
};
